import * as React from 'react';
import { Location } from 'history';
import { WithRouterProps } from 'react-router';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

type LanguageCode = string;

interface Language {
  code: LanguageCode;
  localisedText: string;
}

interface Props {
  selected: LanguageCode;
  languages: Language[];
  onChangeLanguage: (
    language: string,
    location: Location,
    isAuthenticated: boolean,
  ) => void;
  isAuthenticated: boolean;
}

export class LanguageSwitcher extends React.PureComponent<
  Props & WithRouterProps
> {
  handleChange: React.ChangeEventHandler<HTMLSelectElement> = e => {
    const { onChangeLanguage, location, isAuthenticated } = this.props;

    onChangeLanguage(e.target.value, location, isAuthenticated);
  };

  renderValue = (code: string) => code.toUpperCase();

  render() {
    const { selected, languages } = this.props;

    return (
      <div data-test-locator="Language switcher">
        <Select
          value={selected}
          onChange={this.handleChange}
          renderValue={this.renderValue}
          id="Language switcher"
        >
          {languages.map(({ code, localisedText }) => (
            <MenuItem
              key={code}
              value={code}
              data-test-locator={`Option ${code}`}
            >
              {localisedText}
            </MenuItem>
          ))}
        </Select>
      </div>
    );
  }
}

export default LanguageSwitcher;
